/* Copyright 2020 The MathWorks, Inc. */

/**
 * SwatchColorMode can be either 'auto' or 'manual'.
 *
 * In auto mode, the swatchColor will be the same as the selectedColor.
 * Updating selectedColor will also update the swatchColor. User has no control
 * over the swatchColor.
 *
 * In manual mode, user can control the swatchColor. Updating
 * selectedColor will not update the swatchColor.
 */

define([], function () {
    return {
        AUTO: "auto",
        MANUAL: "manual"
    };
});